export { default } from './TextareaAutosize';
export type * from './TextareaAutosize.types';
